/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { CompiledLicenseDTO } from "../models/compiled-license-dto";
import { LicensingService } from "../services/licensing.service";
import { Input, Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";

@Injectable()
//@Input() KHT - using the @Input() tag breaks certain resolvers after Angular 12 update
export class CompiledLicenseResolver implements Resolve<CompiledLicenseDTO> {

  constructor(
    private mLicensingService: LicensingService
  ) {}

  async resolve(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<CompiledLicenseDTO> {
    try {
      return await this.mLicensingService.getCompiledLicense();
    } catch (error) {
      console.error("Problem resolving Compiled License.", error);
    }
  }

}
